<!-- Mobile: Bottom Sheet -->
@if (deviceService.$isMobile() && $modalIsVisible()) {
<lib-bottom-sheet
  [visible]="$modalIsVisible()"
  (visibleChange)="onModalVisibleChange($event)"
  size="full"
  [draggable]="true"
  [closeOnBackdrop]="!$isLoading()"
  [closeOnEscape]="!$isLoading()"
  [preventClose]="$isLoading()"
  [headerTemplate]="headerTemplateView"
  [footerTemplate]="
    $activeTab() === 'agendar'
      ? footerTemplate ?? undefined
      : $activeTab() === 'clientes' && $modoClientes() === 'criar'
      ? footerClienteTemplate
      : undefined
  "
  (hide)="fecharModal()"
>
  <ng-container *ngTemplateOutlet="corpoModal"></ng-container>
</lib-bottom-sheet>
} @else {
<!-- Desktop: Dialog -->
<p-dialog
  [visible]="$modalIsVisible()"
  (visibleChange)="onModalVisibleChange($event)"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [showHeader]="true"
  styleClass="dialog-mobile-scroll rounded-3xl shadow-4"
  [style]="{ height: '660px', width: '700px' }"
  [contentStyle]="{ overflow: 'auto', height: '100%' }"
  (onHide)="fecharModal()"
>
  <ng-template pTemplate="header">
    <ng-container *ngTemplateOutlet="headerTemplateView"></ng-container>
  </ng-template>
  @if ($modalIsVisible()) {
  <ng-container *ngTemplateOutlet="corpoModal"></ng-container>
  }

  <ng-template pTemplate="footer">
    @if ($activeTab() === 'agendar') {
    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
    } @if ($activeTab() === 'clientes' && $modoClientes() === 'criar') {
    <ng-container *ngTemplateOutlet="footerClienteTemplate"></ng-container>
    }
  </ng-template>
</p-dialog>
}

<ng-template #corpoModal>
  @if ($mostrarSkeleton()) {
  <div class="n-novo-agendamento-skeleton" aria-busy="true">
    <p-skeleton width="100%" height="2.875rem" borderRadius="999px" />
    <p-skeleton width="100%" height="3.25rem" borderRadius="999px" />
    <p-skeleton width="7rem" height="0.75rem" />
    @for (card of skeletonCards; track card) {
    <div class="n-skeleton-card">
      <p-skeleton shape="circle" size="2.625rem" />
      <div class="n-skeleton-card-texto">
        <p-skeleton width="62%" height="0.9rem" />
        <p-skeleton width="38%" height="0.7rem" />
      </div>
    </div>
    }
  </div>
  }
  <div [hidden]="$mostrarSkeleton()" [attr.inert]="$mostrarSkeleton() ? '' : null">
    @switch ($activeTab()) { @case ('agendar') {
    <lib-agenda-novo-agendamento
      [agendamento]="agendamento"
      [cliente]="cliente"
      [isEncaixe]="isEncaixe"
      (footerTemplateAction)="footerTemplateAction($event)"
      (loadingChange)="$isLoading.set($event)"
      (agendamentoSalvo)="fecharModal()"
    ></lib-agenda-novo-agendamento>
    } @case ('clientes') {
    <lib-agenda-lista-cliente
      (cliente)="clienteSelecionado($event)"
      (modoChanged)="onModoClientesChanged($event)"
      (footerTemplateAction)="onFooterClienteTemplate($event)"
      (carregamentoInicial)="onListaPronta()"
    ></lib-agenda-lista-cliente>
    } }
  </div>
</ng-template>

<ng-template #footerTemplateView> </ng-template>

<ng-template #footerClienteTemplate>
  <div class="flex gap-2 justify-end w-full">
    <p-button
      [label]="'BARDO_AGENDA.CANCELAR' | translate"
      severity="secondary"
      [outlined]="true"
      (click)="cancelarNovoCliente()"
    />
    @if (footerClienteRef) {
    <ng-container *ngTemplateOutlet="footerClienteRef"></ng-container>
    } @else {
    <p-button [label]="'BARDO_CLIENTES.SALVAR' | translate: { termo: $nicho().cliente.singular }" (click)="salvarNovoCliente()" />
    }

  </div>
</ng-template>

<ng-template #headerTemplateView>
  <div class="w-full">
    <div
      class="pr-1 pl-1 pb-2 pt-2 border-round-lg lg:col-12 n-header-gradient"
    >
      <div class="n-header-content">
        <div class="sm:col-12 md:col-8">
          <span class="n-header-title text-white font-bold">
            <i [class]="isEncaixe ? 'pi pi-bolt mr-2' : 'pi pi-calendar-plus mr-2'"></i>
            {{ isEncaixe ? ('BARDO_AGENDA.NOVO_ENCAIXE' | translate) : $nicho().agendamento.modalTituloNovo }}

          </span>
        </div>
        <div class="sm:col-12 md:col-4 flex justify-content-end gap-2">
          @if (!deviceService.$isMobile()) {
          <button
            type="button"
            class="n-close-btn"
            (click)="fecharModal()"
            [attr.aria-label]="'ACOES.FECHAR' | translate"
          >
            <i class="pi pi-times"></i>
          </button>
          }
        </div>
      </div>
    </div>
    <div class="lg:col-12">
      <p-tabs [value]="$activeTab()" libTabsInkbarFix>
        <p-tablist>
          @for (tab of $tabs(); track tab.id) { @if (tabVisivel(tab.id)) {
          <p-tab
            [value]="tab.id"
            class="flex items-center !gap-2 text-inherit"
            (click)="onTabChange(tab.id)"
          >
            <i [class]="tab.icon"></i>
            <span class="n-display-none">{{ tab.label }}</span>
          </p-tab>
          } }
        </p-tablist>
      </p-tabs>

    </div>
  </div>
</ng-template>
